import AboutSection from "../components/AboutSection";
import Admissions from "../components/Admissions";
import Expo from "../components/Expo";
import Hero from "../components/Hero";
import IntakesSection from "../components/IntakesSection";
import Programs from "../components/Programs";
import StatsBar from "../components/StatsBar";
import Testimonials from "../components/Testimonials";
import WhyUs from "../components/WhyUs";
import { useLandingPageData } from "../hooks/useLandingPageData";
import { usePrograms } from "../hooks/usePrograms";

export default function Home() {
  const { data, loading, error } = useLandingPageData();
  const { programs } = usePrograms();
  const sections = data.sections || {};
  const items = data.items || {};

  if (loading && Object.keys(sections).length === 0) {
    return (
      <section className="section">
        <div className="section__inner">
          <p style={{ textAlign: "center", color: "var(--text-muted)" }}>Loading homepage content...</p>
        </div>
      </section>
    );
  }

  return (
    <>
      {error && (
        <section className="section" aria-label="Homepage warning">
          <div className="section__inner">
            <div className="admin-toast admin-toast--error" style={{ position: "static" }}>
              {error}
            </div>
          </div>
        </section>
      )}

      <Hero section={sections.hero} slides={items.hero_slides || []} programs={programs} />
      <StatsBar section={sections.stats} items={items.stats || []} />
      <AboutSection section={sections.about} highlights={items.about_highlights || []} />
      <Programs section={sections.programs} programs={programs} />
      <WhyUs section={sections.why_us} items={items.why_us_features || []} />
      <IntakesSection section={sections.intakes} items={items.intakes || []} />
      <Expo section={sections.expo} items={items.expo_highlights || []} />
      <Testimonials section={sections.testimonials} items={items.testimonials || []} />
      <Admissions section={sections.admissions} items={items.admissions_steps || []} />
    </>
  );
}
